export enum AlarmStatus {
  Reported = 'Reported',
  Handled = 'Handled',
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
}
